import { change, onSnapshot } from './helpers'

import { GardenContext, GardenState } from '@/types/store'

import plants from '@/store/plants'
import log from '@/store/log'
import images from '@/store/images'

import { db } from '@/firebase'
import { id, uid } from '@/types/models'

import Garden from '@/models/Garden'
import wait from '@/helpers/wait'

export default {
  namespaced: true,
  modules: {
    plants,
    log,
    images,
  },
  state: (): GardenState => ({
    data: [], // Array<Garden>(),

    unbinds: [],
    isInitialized: false,
  }),
  getters: {
    all: (state: GardenState) => state.data,
    find: (state: GardenState) => (gardenId: id) =>
      state.data.find((g: Garden) => g.id === gardenId),
  },
  mutations: {
    change,
    clear(state: GardenState) {
      state.data = []
    },

    addUnbind(state: GardenState, val: () => void) {
      state.unbinds.push(val)
    },
    setInitialized(state: GardenState, val: boolean) {
      state.isInitialized = val
    },
  },
  actions: {
    bind(context: GardenContext, userId: uid) {
      // unsubscribe can be called to stop listening for changes
      const unsubscribe = db.onCollectionSnapshot(
        db.query(
          db.collection('gardens').withConverter(Garden.firestoreConverter()),
          db.where(`roles.${userId}`, 'in', ['owner'])
        ),
        (ref) => onSnapshot(context, ref)
      )

      // save unbind function to store
      context.commit('addUnbind', unsubscribe)

      wait(5 * 1000).then(() => context.commit('setInitialized', true))
    },
    unbind(context: GardenContext) {
      // unsubscribe from firestore
      context.state.unbinds.forEach((fn) => fn())

      // clear from vuex store
      context.commit('clear')

      // TODO: unbind children based on collections() instead of root
    },
  },
}
